import { useMemo } from "react";
import { useLocation } from "react-router";

/**
 * Hook to extract map centering coordinates and customer scope from URL search parameters.
 *
 * @returns Object containing defaultCenter, defaultLatitude, defaultLongitude, and defaultCustomerScope
 */
export function useDefaultCenter() {
  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);

  const defaultLatitude = Number(query.get("lat"));
  const defaultLongitude = Number(query.get("lng"));

  const rawScope = query.get("customerScope") || query.get("ags") || undefined;
  const defaultCustomerScope = rawScope
    ? (rawScope.startsWith("AGS_") || rawScope.startsWith("ZV_") ? rawScope : `AGS_${rawScope}`)
    : undefined;

  const defaultCenter = useMemo(
    () => ({ lat: Number(defaultLatitude), lng: Number(defaultLongitude) }),
    [defaultLatitude, defaultLongitude]
  );

  return {
    defaultCenter,
    defaultLatitude,
    defaultLongitude,
    defaultCustomerScope,
  };
}